import React from 'react'
import Element from 'layouts/Element'

export default class FlexBox extends Element {
  static get defaultProps () {
    return {
      spaceBetween: false,
      alignCenter: false
    }
  }

  get defaultClassNames () {
    const { spaceBetween, alignCenter } = this.props

    return [
      'flex-box',
      spaceBetween ? 'space-between' : null,
      alignCenter ? 'align-center' : null
    ].filter(c => c)
  }

  render () {
    return (
      <div className={this.classNames}>
        {this.props.children}
      </div>
    )
  }
}
